module.exports = __webpack_public_path__ + "img/ico10.3106c865.svg";